import { createElement } from 'react';
import ReactDOM from 'react-dom';

function reactRender(App, props = {}) {
  document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(createElement(App, props), document.getElementById('react-root'));
  });
}

export default reactRender;
